export default __webpack_public_path__ + "static/media/windows-amico.b5cc9d1b.svg";